/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum GastherapyStartOrRestartModalAliases {
  ACCORDION_INFORMATION = 'accordion-information',
  BUTTON_EXECUTE = 'button-execute',
  CONTENT_INFORMATION_HEADER = 'content-information-header',
  DATE_HOUR_FIELD = 'date-hour-field',
  DATE_HOUR_INPUT = 'date-hour-input',
  FI_O2_FIELD = 'FiO2-field',
  FI_O2_INPUT = 'FiO2-input',
  GASTHERAPY_BREATHING_TYPE = 'gastherapy-breathing-type',
  GASTHERAPY_EXECUTE_LAYOUT = 'gastherapy-execute-layout',
  GASTHERAPY_RESPIRATORY_MODALITY = 'gastherapy-respiratory-modality',
  GASTHERAPY_START_BARCODE = 'gastherapy-start-barcode',
  GASTHERAPY_START_BARCODE_PANEL = 'gastherapy-start-barcode-panel',
  GASTHERAPY_START_DEVICE_AUTOCOMPLETE = 'gastherapy-start-device-autocomplete',
  GASTHERAPY_START_DEVICE_FETCH = 'gastherapy-start-device-fetch',
  GASTHERAPY_START_DEVICE_FIELD = 'gastherapy-start-device-field',
  GASTHERAPY_START_DEVICE_MAPPER = 'gastherapy-start-device-mapper',
  GASTHERAPY_START_DEVICE_TEXT = 'gastherapy-start-device-text',
  GASTHERAPY_START_OR_RESTART_FORM = 'gastherapy-start-or-restart-form',
  GLOBAL_ACTIONS_EXECUTE = 'global-actions-execute',
  INFORMATION_FIELD = 'information-field',
  INFORMATION_TEXT = 'information-text',
  JUSTIFICATION_FIELD = 'justification-field',
  JUSTIFICATION_TEXT_AREA = 'justification-text-area',
  PANEL_ACCORDION_INFORMATION = 'panel-accordion-information',
  PANEL_FORM_INFORMATION = 'panel-form-information',
  PANEL_INFORMATION_HEADER = 'panel-information-header',
  QUANTITY_FIELD = 'quantity-field',
  QUANTITY_INPUT = 'quantity-input',
  TEXT_GASTHERAPY_DATE = 'text-gastherapy-date',
  TEXT_GASTHERAPY_INFORMATION = 'text-gastherapy-information',
}
export { GastherapyStartOrRestartModalAliases };
